(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-utils/string-format/assets/prescript.js') >= 0) return;  svs.modules.push('/components/tb-utils/string-format/assets/prescript.js');
'use strict';

svs.components = svs.components || {};
svs.components.tbUtils = svs.components.tbUtils || {};
svs.components.tbUtils.stringFormat = svs.components.tbUtils.stringFormat || {};
svs.components.tbUtils.stringFormat.logger = new svs.core.log.Logger('component:string-format');

 })(window);